// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"f555516f","98":"6748a8fa","121":"b0c0b462","189":"2417b485","195":"845baff1","215":"8ba46df6","337":"3feb5cb7","426":"35fc401c","637":"2d6d43ee","787":"d3361df2","824":"2480f4a0","832":"ab5135b4","989":"5d5448f7"}[chunkId] + ".chunk.js";
};